import { Box, Stack, Typography } from "@mui/material";
import { usePostHog } from "posthog-js/react";
import { useNavigate } from "react-router-dom";

import { captureCarrierUpgradeCtaClicked } from "utils";

import {
  CARRIER_UPGRADE_RELATIVE_URL,
  CarrierUpgradeSource,
} from "../../../../constants";

export function CarrierPayPerBookingCenterBannerText() {
  const navigate = useNavigate();
  const posthog = usePostHog();

  const onClick = () => {
    captureCarrierUpgradeCtaClicked(
      posthog,
      CarrierUpgradeSource.PAY_PER_BOOKING_BANNER,
    );
    navigate(CARRIER_UPGRADE_RELATIVE_URL);
  };

  return (
    <Box
      sx={{
        "&:hover": {
          cursor: "pointer",
        },
      }}
      onClick={onClick}
    >
      <Stack direction="column" alignItems="center">
        <Typography variant="h6" color="white">
          Do not miss out on premium features!
        </Typography>
        <Typography variant="h6" color="yellow">
          <u>View Premium Plans</u>
        </Typography>
      </Stack>
    </Box>
  );
}
